import * as React from 'react';
import {Link} from 'react-router-dom';

import './styles.css';

export default (): JSX.Element => {
  return (
    <div className='page404'>
      <div className='texts'>
        <h1>Page Not Found</h1>
      </div>
      <div className='container'>
        <div className='error404page'>
          <Link to='/'>
            <div className='newcharacter404'>
              <div className='chair404' />
              <div className='leftshoe404' />
              <div className='rightshoe404' />
              <div className='legs404' />
              <div className='torso404'>
                <div className='body404' />
                <div className='leftarm404' />
                <div className='rightarm404' />
                <div className='head404'>
                  <div className='eyes404' />
                </div>
              </div>
              <div className='laptop404' />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
